import { Component } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ThemeService } from '@app/theme';
import { NzNotificationService } from 'ng-zorro-antd';
import { AccountService } from '../../services/account.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent {
  loading: boolean;

  form = this.fb.group({
    accountField: ['', Validators.compose([Validators.required, Validators.email])]
  });

  constructor(
    private fb: FormBuilder,
    private accountService: AccountService,
    private notification: NzNotificationService,
    private themeService: ThemeService
  ) {}

  async sendEmail() {
    this.loading = true;
    try {
      const res = await this.accountService.sendEmail(this.form.value.accountField).toPromise();
      this.notification.info(res.message, null);
    } catch (err) {
      console.error(err);
    }
    this.loading = false;
  }

  isThemeActiveReceitaDigital() {
    const active = this.themeService.getActiveTheme();
    return active.name === 'theme-receita-digital';
  }
}
